import { render } from "./table-ajax.vue?vue&type=template&id=2ae453f4"
import script from "./table-ajax.vue?vue&type=script&lang=js"
export * from "./table-ajax.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__